import { application } from '../application'

// Shared
import Shared_CookiesRequiredController from '../shared/cookies_required_controller.js'
application.register('cookies-required', Shared_CookiesRequiredController)

import Shared_FormController from '../shared/form_controller.js'
application.register('form', Shared_FormController)

// SSO
import SignUpIn_SSOController from './sso_controller.js'
application.register('sso', SignUpIn_SSOController)

// Cloudflare Turnstile
import SignUpIn_CloudFlareTurnstileController from './cloudflare_turnstile_controller.js'
application.register('cloudflare-turnstile', SignUpIn_CloudFlareTurnstileController)
